'use strict';

import React from 'react';
import PropTypes from "prop-types";
import classNames from 'classnames';
import { ReCron } from '@sbzen/re-cron';

export default class CronFormatter extends React.PureComponent {
    static propTypes = {
        onCronChanged: PropTypes.func,
        cronValue: PropTypes.string
    }

    static defaultProps = {
        onCronChanged: () => { },
        cronValue: '* * * * * *'
    }

    constructor(props) {
        super(props);
        const isCronValid = this.checkIfCronValid(this.props.cronValue);
        this.state = {
            cronValue: isCronValid ? this.props.cronValue : '* * * * * *',
            cronEditedValue: this.props.cronValue,
            isCronValid: isCronValid
        };
    }
    checkIfCronValid = (value) => {
        if (value.split("L").length > 2) {
            return false;
        }
        const cronRegex = RegExp(
            `^\\s*($|#|\\w+\\s*=|(\\?|\\*|(?:[0-5]?\\d)(?:(?:-|\/|\\,)(?:[0-5]?\\d))?(?:,(?:[0-5]?\\d)(?:(?:-|\/|\\,)(?:[0-5]?\\d))?)*)\\s+(\\?|\\*|(?:[0-5]?\\d)(?:(?:-|\/|\\,)(?:[0-5]?\\d))?(?:,(?:[0-5]?\\d)(?:(?:-|\/|\\,)(?:[0-5]?\\d))?)*)\\s+(\\?|\\*|(?:[01]?\\d|2[0-3])(?:(?:-|\/|\\,)(?:[01]?\\d|2[0-3]))?(?:,(?:[01]?\\d|2[0-3])(?:(?:-|\/|\\,)(?:[01]?\\d|2[0-3]))?)*)\\s+(\\?|\\*|L(W|-(?:0?[1-9]|[12]\\d|3[01]))?|(?:0?[1-9]|[12]\\d|3[01])W|(?:0?[1-9]|[12]\\d|3[01])(?:(?:-|\/|\\,)(?:0?[1-9]|[12]\\d|3[01]))?(?:,(?:0?[1-9]|[12]\\d|3[01])(?:(?:-|\/|\\,)(?:0?[1-9]|[12]\\d|3[01]))?)*)\\s+(\\?|\\*|(?:[1-9]|1[012])(?:(?:-|\/|\\,)(?:[1-9]|1[012]))?(?:L|W)?(?:,(?:[1-9]|1[012])(?:(?:-|\/|\\,)(?:[1-9]|1[012]))?(?:L|W)?)*|\\?|\\*|(?:JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)(?:(?:-)(?:JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC))?(?:,(?:JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)(?:(?:-)(?:JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC))?)*)\\s+(\\?|\\*|(?:[0-6])(?:(?:-|\/|\\,|#)(?:[0-6]))?(?:L)?(?:,(?:[0-6])(?:(?:-|\/|\\,|#)(?:[0-6]))?(?:L)?)*|\\?|\\*|(?:MON|TUE|WED|THU|FRI|SAT|SUN)(?:(?:-)(?:MON|TUE|WED|THU|FRI|SAT|SUN))?(?:,(?:MON|TUE|WED|THU|FRI|SAT|SUN)(?:(?:-)(?:MON|TUE|WED|THU|FRI|SAT|SUN))?)*)(|\\s)+(\\?|\\*|(?:|\\d{4})(?:(?:-|\/|\\,)(?:|\\d{4}))?(?:,(?:|\\d{4})(?:(?:-|\/|\\,)(?:|\\d{4}))?)*))$`
        );
        return cronRegex.test(value);
    }
    removeYearsFromCronSetting = (value) => {
        return value.split(" ").slice(0, -1).join(" ");
    }
    handleChange = (cronValue) => {
        const cron = this.removeYearsFromCronSetting(cronValue);
        this.setState({
            isCronValid: true,
            cronValue: cron,
            cronEditedValue: cron
        });
        this.props.onCronChanged(cron);
    }

    setCronValueInput = (e) => {
        const value = e.target.value;
        const isCronValid = this.checkIfCronValid(value);
        this.setState({
            cronEditedValue: value,
            isCronValid: isCronValid,
            cronValue: isCronValid ? value : this.state.cronValue
        });
        if (isCronValid) {
            this.props.onCronChanged(value);
        }
    }

    render() {
        const cronLabelClassNames = classNames(
            'control-label',
            {
                'cron-container_input_value-invalid': !this.state.isCronValid
            }
        );
        const cronInputClassNames = classNames(
            'form-control',
            {
                'cron-container_input_input-invalid': !this.state.isCronValid
            }
        );
        return (
            <div className="cron-container">
                <div className="input-group cron-container_input">
                    <label className={cronLabelClassNames}>CRON</label>
                    <input
                        className={cronInputClassNames}
                        type="text"
                        value={this.state.cronEditedValue}
                        onChange={this.setCronValueInput} />
                </div>
                <ReCron
                    value={this.state.cronValue}
                    onChange={this.handleChange}>
                </ReCron>
            </div >

        );
    }
}
